import { useAccount, useAccountImpacts, useProductImpacts } from 'src/hooks'
import { IProduct } from 'src/types'
import { aggregateImpacts } from 'src/utils/impact.util'

import { Content } from './content.component'
import { useTranslation } from 'react-i18next'

interface IProps {
  product: IProduct
  primaryColor: string
}

export const ProductCard = ({ product, primaryColor }: IProps) => {
  const [, i18n] = useTranslation()
  const { data: account } = useAccount(product.account_id, i18n.language)
  const { data } = useProductImpacts(product.id, i18n.language)
  const { data: accountImpacts } = useAccountImpacts(i18n.language, null, product.id)

  const { impactsToShow, isImpactsPage } = aggregateImpacts({
    accountImpacts,
    productImpacts: product.impacts,
    stepsImpacts: data?.impacts,
  })

  if (!account) return null

  return (
    <Content
      id={product.id}
      aiGenerated={product.ai_generated}
      media={product.media}
      productDescription={product.description}
      productName={product.name}
      accountImage={account.image_small || account.image}
      accountHolder={account.account_holder}
      impacts={impactsToShow}
      isImpactsPage={isImpactsPage}
      showMedia={product.showMedia}
      hideAccountName={account.hide_name}
      hideProductName={account.hide_product_name}
      accountId={product.account_simple_id}
      primaryColor={primaryColor}
      walletAddress={account.wallet_address}
      showWalletAddress={account.show_wallet_address}
      showBcInfo={account.show_bc_info}
    />
  )
}
